// import '~/js/modules/stickyNav';
import '~/js/modules/section-hero';
//import 'slick-carousel';

const $levelSelect = $('#levelSelect');
// const { displayDiveSitesFrom = '' } = window.beaches_app.page;
const activeItem = document.querySelector('[data-select-level="13"]');

  activeItem.classList.add('active');

$(document).on('click', '[data-select-level]', function selectLevel() {
  const diveLevel = Number($(this).data('select-level'));
  $(this).addClass('active').siblings().removeClass('active');
  $('.js-dive-level').removeClass('show');
  $('[data-level="' + diveLevel + '"]').addClass('show');
}); 
  

// CAROUSEL
const rates = window.beaches_app.page.rates;
const $averageRate = $('#averageRate');
const $childRate = $('#childRate');
//const $carousel = $('.js-carousel');
let childRateLowest;
let averageRateLowest;

// Initialization carousel
//$carousel.slick({
//  prevArrow: '<button class="rooms-prev icon-link-arrow-beaches"></button>',
//  nextArrow: '<button class="rooms-next icon-link-arrow-beaches"></button>',
//});

$.each(rates, (index, value) => {
  if(!childRateLowest || value[0].childRate < childRateLowest) {
    childRateLowest = value[0].childRate;
  }
  if(!averageRateLowest || value[0].averageRate < averageRateLowest) {
    averageRateLowest = value[0].averageRate;
  }
});

$childRate.html('<span>$</span>' + childRateLowest);
$averageRate.html('<span>$</span>' + averageRateLowest);

/*
//------ Carousel
const $resortCarousel = $('#inc-carousel');
const $control = $('#inc-carousel-control');

const $counter = $('.carousel-counter');

$resortCarousel.on('init reInit afterChange', (event, slick, currentSlide, nextSlide) => {
  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  const i = (currentSlide ? currentSlide : 0) + 1;

  $counter.text(i + '/' + slick.slideCount);
});

$resortCarousel.slick({
  appendArrows: $control,
  mobileFirst: true,
  variableWidth: true,
  centerMode: true,
  arrows: true,
  prevArrow: '<button class="icon-button-prev arrow-prev"></button>',
  nextArrow: '<button class="icon-button-next arrow-next"></button>',
});

//------ Carousel
const $resortCarousel2 = $('#inc-carousel2');
const $control2 = $('#inc-carousel-control2');

const $counters = $('.carousel-counter2');

$resortCarousel2.on('init reInit afterChange', (event, slick, currentSlides, nextSlide) => {
  // currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  const i = (currentSlides ? currentSlides : 0) + 1;

  $counter.text(i + '/' + slick.slideCount);
});

$resortCarousel2.slick({
  appendArrows: $control2,
  mobileFirst: true,
  variableWidth: true,
  centerMode: true,
  arrows: true,
  prevArrow: '<button class="icon-button-prev arrow-prev"></button>',
  nextArrow: '<button class="icon-button-next arrow-next"></button>',
});

//------ Carousel
const $resortCarousel3 = $('#inc-carousel3');
const $control3 = $('#inc-carousel-control3');

const $counters3 = $('.carousel-counter3');

$resortCarousel3.on('init reInit afterChange', (event, slick, currentSlides, nextSlide) => {
  // currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  const i = (currentSlides ? currentSlides : 0) + 1;

  $counter.text(i + '/' + slick.slideCount);
});

$resortCarousel3.slick({
  appendArrows: $control3,
  mobileFirst: true,
  variableWidth: true,
  centerMode: true,
  arrows: true,
  prevArrow: '<button class="icon-button-prev arrow-prev"></button>',
  nextArrow: '<button class="icon-button-next arrow-next"></button>',
}); */